import { render } from "./ModalPrintOrder.vue?vue&type=template&id=1ba18a8e"
import script from "./ModalPrintOrder.vue?vue&type=script&lang=js"
export * from "./ModalPrintOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__